import { useEffect, useState } from "react";

let open = false;
const subs = new Set();
const emit = () => subs.forEach((f) => f(open));

export const startTour = () => { open = true; emit(); };
export const endTour = () => { open = false; emit(); };

export function useTourOpen() {
  const [o, setO] = useState(open);
  useEffect(() => { subs.add(setO); return () => subs.delete(setO); }, []);
  return o;
}
